var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[_c('h1',[_c('a',{attrs:{"href":"https://www.plotbridge.io/guidesub/marketguide/","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("guide-market"))+" ")])]),_c('el-col',[_c('p',[_vm._v(_vm._s(_vm.$t("guide-market1")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }